var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{attrs:{"app":""}},[_c('Subtitle',[_vm._v("시설안내")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }